// app/frontend/data/testimonials.ts
import { Testimonial } from "./types";

// Testimonials pulled from the NeoKiz 2024 post-festival survey.
// Real attendees, real quotes. Source: Master Testimonials/Reviews Database (Notion).
export const testimonials: Testimonial[] = [
  {
    id: 1,
    name: "Nii Ashikwei",
    text: "By far one of my favourite festivals. Thank you for your dedication to growth, improvement, iteration over feedback. Please keep doing everything you're doing!",
    title: "NeoKiz 2024 attendee",
    rating: 5,
    source: "NeoKiz 2024 Survey",
    date: "2024-05-01",
    featured: true,
    tags: ["Dance", "NeoKiz 2024", "General"],
  },
  {
    id: 2,
    name: "Sanchita Dasgupta",
    text: "Love how organised it was. It was my best festival yet! I had some deeply emotional experiences and I look forward to coming back next year!",
    title: "NeoKiz 2024 attendee",
    rating: 5,
    source: "NeoKiz 2024 Survey",
    date: "2024-05-01",
    featured: true,
    tags: ["Dance", "NeoKiz 2024", "General"],
  },
  {
    id: 3,
    name: "Crystal Dismuke",
    text: "The night socials, switch hour, convenience of all in one hotel experience, pool parties! One of my literal favorite festivals! Well done!",
    title: "NeoKiz 2024 attendee",
    rating: 5,
    source: "NeoKiz 2024 Survey",
    date: "2024-05-01",
    featured: true,
    tags: ["Dance", "NeoKiz 2024", "General"],
  },
  {
    id: 4,
    name: "Tamara Perrotte",
    text: "I have enjoyed everything. From the location, the connections made between the artists, vendors, attendees, DJ, and more. This festival has always been special to me and this year more so — I couldn't be happier to have chosen this event to return after such a long dance hiatus.",
    title: "NeoKiz 2024 attendee",
    rating: 5,
    source: "NeoKiz 2024 Survey",
    date: "2024-05-01",
    featured: true,
    tags: ["Dance", "NeoKiz 2024", "General"],
  },
  {
    id: 5,
    name: "Esosa Uwadiae",
    text: "The organization did an amazing job in ensuring a positive experience for the attendees. The DJs did an amazing job keeping the energy high. I've never been to a pool party before, and felt so comfortable with leads that knew my boundaries.",
    title: "NeoKiz 2024 attendee",
    rating: 5,
    source: "NeoKiz 2024 Survey",
    date: "2024-05-01",
    featured: true,
    tags: ["Dance", "NeoKiz 2024", "Culture", "Safety"],
  },
  {
    id: 6,
    name: "Kenn Klick",
    text: "It was a beautiful enlightening experience that I found impacted the rest of my weekend. I found moments where communicating would have improved the shared dance experience when I dropped into old routine social dancing habits.",
    title: "NeoKiz 2024 attendee",
    rating: 5,
    source: "NeoKiz 2024 Survey",
    date: "2024-05-01",
    featured: true,
    tags: ["Dance", "NeoKiz 2024", "Consent"],
  },
  {
    id: 7,
    name: "Jayde Piot",
    text: "The quality and level of classes this year was higher. I appreciated the variety of styles instructors brought along side their own ways of teaching, and their diverse personalities made it more interesting.",
    title: "NeoKiz 2024 attendee",
    rating: 5,
    source: "NeoKiz 2024 Survey",
    date: "2024-05-01",
    featured: false,
    tags: ["Dance", "NeoKiz 2024", "Workshops"],
  },
  {
    id: 8,
    name: "Kiely Hosmon",
    text: "I've only been dancing urban kiz for a couple of years, but I know that this festival is 'the' festival to go to. I had a great time and I can't wait to come back.",
    title: "NeoKiz 2024 attendee",
    rating: 5,
    source: "NeoKiz 2024 Survey",
    date: "2024-05-01",
    featured: false,
    tags: ["Dance", "NeoKiz 2024", "General"],
  },
  {
    id: 9,
    name: "Millan Singh",
    text: "The fundamentals track was wonderful! The instructors focused on developing the core fundamentals of the dance which I appreciated and found really helpful.",
    title: "NeoKiz 2024 attendee",
    rating: 5,
    source: "NeoKiz 2024 Survey",
    date: "2024-05-01",
    featured: false,
    tags: ["Dance", "NeoKiz 2024", "Fundamentals"],
  },
  {
    id: 10,
    name: "Shelbee Jaeger",
    text: "I very much enjoyed my experience and am very grateful for everyone who made this event possible. I cannot imagine how much work it is and am so impressed with the organization.",
    title: "NeoKiz 2024 attendee",
    rating: 5,
    source: "NeoKiz 2024 Survey",
    date: "2024-05-01",
    featured: false,
    tags: ["Dance", "NeoKiz 2024", "Production"],
  },
  {
    id: 11,
    name: "Cynthia Hauk",
    text: "Thank you for all of your hard work and efforts to create a magical NeoKiz festival!",
    title: "NeoKiz 2024 attendee",
    rating: 5,
    source: "NeoKiz 2024 Survey",
    date: "2024-05-01",
    featured: false,
    tags: ["Dance", "NeoKiz 2024", "General"],
  },
  {
    id: 12,
    name: "Sarah Bailey",
    text: "Great job! Still one of my favorite dance festivals!",
    title: "NeoKiz 2024 attendee",
    rating: 5,
    source: "NeoKiz 2024 Survey",
    date: "2024-05-01",
    featured: false,
    tags: ["Dance", "NeoKiz 2024", "General"],
  },
];

// Helper functions
export function getFeaturedTestimonials(): Testimonial[] {
  return testimonials.filter((t) => t.featured);
}

export function getTestimonialsByTag(tag: string): Testimonial[] {
  return testimonials.filter((t) => t.tags.includes(tag));
}

export function getAllTestimonialTags(): string[] {
  return Array.from(new Set(testimonials.flatMap((t) => t.tags)));
}

export function getVideoTestimonials(): Testimonial[] {
  return testimonials.filter((t) => t.videoUrl);
}

export function getTextTestimonials(): Testimonial[] {
  return testimonials.filter((t) => !t.videoUrl);
}
